import { StyleSheet } from 'react-native';

import { noOutline } from '../view-style';

export default StyleSheet.create({
  textInput: {
    minWidth: 55,
    maxWidth: 200,
    height: 23,
    borderBottomWidth: 2,
    marginLeft: 5,
    paddingHorizontal: 2,
    fontSize: 16,
    textAlign: 'center',
    ...noOutline,
    paddingVertical: 0,
  },
  completedText: {
    fontWeight: 'bold',
    fontSize: 22,
  },
});
